(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-on-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('social-post-grid')) {
  customElements.define('social-post-grid', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.dataset.visible = entry.isIntersecting ? 'true' : 'false';
        this.syncVideo(entry.target);
      }), { threshold: 0.5 });
      this.querySelectorAll('.ig-post').forEach(post => {
        const slides = [...post.querySelectorAll('.ig-slide')];
        slides.forEach((slide, i) => { slide.hidden = i !== 0; });
        post.dataset.index = '0';
        post.querySelectorAll('video').forEach(video => { video.muted = true; video.playsInline = true; this.observer.observe(video); });
        this.updateButton(post);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        const post = button.closest('.ig-post');
        const slides = [...post.querySelectorAll('.ig-slide')];
        if (button.matches('.ig-play')) {
          const video = slides[Number(post.dataset.index)]?.querySelector('video');
          if (!video) return;
          video.dataset.userPaused = video.paused ? 'false' : 'true';
          video.dataset.userPlayed = video.paused ? 'true' : 'false';
          if (video.paused) video.play().then(() => this.updateButton(post)).catch(() => this.updateButton(post));
          else { video.pause(); this.updateButton(post); }
          return;
        }
        if (!button.hasAttribute('data-step') && !button.hasAttribute('data-slide')) return;
        const index = button.hasAttribute('data-slide') ? Number(button.dataset.slide) : (Number(post.dataset.index) + Number(button.dataset.step) + slides.length) % slides.length;
        post.dataset.index = String(index);
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.querySelectorAll('video').forEach(video => this.syncVideo(video)); });
        post.querySelectorAll('[data-slide]').forEach(dot => dot.setAttribute('aria-current', String(Number(dot.dataset.slide) === index)));
        this.updateButton(post);
      }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.querySelectorAll('video').forEach(video => this.syncVideo(video)), { signal: this.abort.signal });
      this.reduced.addEventListener('change', () => this.querySelectorAll('video').forEach(video => this.syncVideo(video)), { signal: this.abort.signal });
    }
    syncVideo(video) {
      const active = !video.closest('.ig-slide').hidden && video.dataset.visible === 'true' && !document.hidden;
      if (active && video.dataset.userPaused !== 'true' && (!this.reduced.matches || video.dataset.userPlayed === 'true')) {
        video.play().then(() => this.updateButton(video.closest('.ig-post'))).catch(() => this.updateButton(video.closest('.ig-post')));
      } else { video.pause(); this.updateButton(video.closest('.ig-post')); }
    }
    updateButton(post) {
      const button = post.querySelector('.ig-play');
      if (!button) return;
      const video = post.querySelectorAll('.ig-slide')[Number(post.dataset.index)]?.querySelector('video');
      button.hidden = !video;
      button.style.display = video ? '' : 'none';
      if (video) { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-quick-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('quick-filters')) return;

    const SECTION_PREFIX = 'shopify-section-';
    let controller = null;

    const getMain = () => document.querySelector('main') || document.body;

    const sectionIds = (onlyQuickFilters = false) => {
      const scope = onlyQuickFilters
        ? [...document.querySelectorAll('quick-filters')].map((el) => el.closest('.shopify-section'))
        : [...getMain().querySelectorAll('.shopify-section')];
      return scope
        .filter((s) => s && s.id.startsWith(SECTION_PREFIX))
        .map((s) => s.id.slice(SECTION_PREFIX.length));
    };

    // Fetch sections for a URL (max 5 per request) and swap their content
    const render = async (href, ids) => {
      controller?.abort();
      controller = new AbortController();
      const url = new URL(href, window.location.origin);
      const chunks = [];
      for (let i = 0; i < ids.length; i += 5) chunks.push(ids.slice(i, i + 5));

      const results = await Promise.all(
        chunks.map(async (chunk) => {
          const u = new URL(url);
          u.searchParams.set('sections', chunk.join(','));
          const res = await fetch(u, { signal: controller.signal });
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
      );

      const parser = new DOMParser();
      results.forEach((json) => {
        Object.entries(json).forEach(([id, html]) => {
          if (!html) return;
          const current = document.getElementById(SECTION_PREFIX + id);
          const fresh = parser.parseFromString(html, 'text/html').getElementById(SECTION_PREFIX + id);
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        });
      });
    };

    const navigate = async (href, push = true) => {
      const main = getMain();
      main.setAttribute('aria-busy', 'true');
      try {
        if (push) history.pushState({ quickFilters: true }, '', href);
        await render(href, sectionIds());
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = href;
      } finally {
        main.removeAttribute('aria-busy');
      }
    };

    class QuickFilters extends HTMLElement {
      connectedCallback() {
        this.renderedSearch = window.location.search;
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
      onClick = (event) => {
        const link = event.target.closest('a.cqf__btn');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.Shopify && window.Shopify.designMode) return; // keep theme editor behavior simple
        event.preventDefault();
        navigate(link.href);
      };
    }
    customElements.define('quick-filters', QuickFilters);

    // Back / forward buttons
    window.addEventListener('popstate', () => {
      if (document.querySelector('quick-filters')) navigate(window.location.href, false);
    });

    // Keep buttons in sync when the theme's own filters change the URL
    let syncTimer = null;
    const observer = new MutationObserver(() => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        const el = document.querySelector('quick-filters');
        if (!el || el.renderedSearch === window.location.search) return;
        el.renderedSearch = window.location.search;
        render(window.location.href, sectionIds(true)).catch(() => {});
      }, 250);
    });
    const start = () => observer.observe(getMain(), { childList: true, subtree: true });
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
